import { Injectable, NgZone } from '@angular/core';

const LANG_KEY = 'selectedLanguage';

@Injectable({ providedIn: 'root' })
export class GoogleTranslateService {
  private isTranslating = false;
  private scriptLoaded = false;

  constructor(private ngZone: NgZone) {}

  init() {
    const savedLang = localStorage.getItem(LANG_KEY);
    if (savedLang) {
      this.applyLanguage(savedLang);
    }
  }

  changeLanguage(lang: string) {
    this.setCookie(lang); //  important for deployed env
    localStorage.setItem(LANG_KEY, lang);
    this.applyLanguage(lang);
  }

  private applyLanguage(lang: string) {
    if (this.isTranslating) return;

    this.ngZone.runOutsideAngular(() => {
      const interval = setInterval(() => {
        const select = document.querySelector(
          '.goog-te-combo'
        ) as HTMLSelectElement;

        if (select) {
          this.isTranslating = true;

          // Check if option exists, sometimes Google hasn't fully rendered the list yet
          let optionTarget = select.querySelector(
            `option[value="${lang}"]`
          ) as HTMLOptionElement;
          if (!optionTarget) {
            optionTarget = document.createElement('option');
            optionTarget.value = lang;
            optionTarget.text = lang;
            select.appendChild(optionTarget);
          }

          select.value = lang;

          // Delay dispatching to ensure Google has bound its event listeners on the dropdown!
          setTimeout(() => {
            select.dispatchEvent(
              new Event('change', { bubbles: true, cancelable: true })
            );
          }, 500);

          clearInterval(interval);

          setTimeout(() => {
            this.isTranslating = false;
          }, 2000);
        }
      }, 300);
    });
  }

  private setCookie(lang: string) {
    const hostname = window.location.hostname;

    //  Handles subdomains
    const domain =
      hostname.includes('.') && hostname !== 'localhost'
        ? '.' + hostname.split('.').slice(-2).join('.')
        : hostname;

    // Erase the old cookie first just in case
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    if (domain !== 'localhost') {
      document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
    }

    document.cookie =
      `googtrans=/en/${lang};path=/;` +
      (domain !== 'local' ? `domain=${domain};` : '');
  }
}
